/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import { VApplication } from "../../application";
import { LoggerModule } from "@vlinder-web/logger-module-react";
import { getAgent } from "./agent";
import { ISwitchSectionArgs } from "./components";

const is = require("is_js");

const SERVICE_NAME = "SwitchSectionPageService";
const log: any = LoggerModule.getInstance();

export class SwitchSectionPagService {
  private static instance: SwitchSectionPagService;
  private vapp: VApplication;
  private selectedCostume: any;

  private constructor(props: any = {}) {
    this.vapp = VApplication.getInstance();
  }

  public static getInstance(props: any = {}): SwitchSectionPagService {
    if (!SwitchSectionPagService.instance) {
      SwitchSectionPagService.instance = new SwitchSectionPagService(props);
    }
    return SwitchSectionPagService.instance;
  }

  public setSelectedCostume(data: any) {
    this.selectedCostume = data;
  }

  public getSelectedCostume() {
    return this.selectedCostume;
  }

  public getStaticPageContent() {
    let content: any = {};
    let compProps: any = null;
    const agent = getAgent();

    compProps = agent.getStaticPageContentSync({});
    if (compProps) {
      content = { ...content, ...compProps };
    }

    return content;
  }

  public async getPresentation(presentationId: string) {
    let content: any = {};
    const agent = getAgent();

    content = await agent.getPresentation(presentationId);

    return content;
  }

  public async getCostumeType(costumeId: string) {
    let content: any = {};
    const agent = getAgent();

    content = await agent.getCostumeType(costumeId);

    return content;
  }

  public async switchSection(payload: ISwitchSectionArgs) {
    let content: any = {};
    const agent = getAgent();

    content = await agent.switchSection(payload);

    return content;
  }
}
